"use client";

import { Pin, X } from "lucide-react";
import type { PinSnapshot } from "@/lib/pin";

export function PinIndicator({
  pin,
  onClear,
}: {
  pin: PinSnapshot;
  onClear: () => void;
}) {
  const label = `${pin.workbookName} · ${pin.address}`;
  return (
    <div
      role="status"
      aria-label={`Pinned: ${label}`}
      className="inline-flex items-center gap-1 rounded-full bg-[var(--brand-accent)]/15 px-2 py-1 text-[12px] text-[var(--brand-accent)]"
    >
      <Pin size={12} strokeWidth={1.5} />
      <span className="max-w-[200px] truncate">{label}</span>
      <button
        onClick={onClear}
        aria-label="Clear pinned dataset"
        className="ml-1 text-[var(--brand-accent)] hover:opacity-80"
      >
        <X size={12} strokeWidth={1.5} />
      </button>
    </div>
  );
}
